import Principal1 from "./component/Principal1";

const PrincipalSection = ({ content, setContent, webColor }: any) => {
  return (
    <Principal1 content={content} setContent={setContent} webColor={webColor} />
  );
};

export default PrincipalSection;
